'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	ColorHelper = require('../models/color-helper');

require('./section-handler-widget');
require('./typeahead');
mmWidgets.fn.colorPickerWidget = function (colorPickerModel, optional = {}) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			colorHelper = optional.colorHelper || new ColorHelper(),
			template = widget.find('[data-mm-swatch-template]'),
			pickImageButton = widget.find('[data-mm-role=pick-image]'),
			imageUploadProgress = widget.find('[data-mm-role=upload-progress]'),
			standardSwatches = widget.find('[data-mm-role="standard-colors"]'),
			inMapSwatches = widget.find('[data-mm-role="in-map-colors"]'),
			changeColor = function (val) {
				const color = val && colorHelper.validColor(val.toLowerCase());
				if (color || val === 'default') {
					colorPickerModel.colorPicked(color);
					widget.addClass('hidden');
				}
			},
			formatTemplate = function (item, currentValue/*, searchString*/) {
				item.find('[data-mm-role=color]').css('background-color', currentValue);
				item.find('[data-mm-role=content]').text(currentValue);
			},
			hexedColor = c => c.startsWith('#') ? c : `#${c}`,
			populateColors = (container, colorList) => {
				colorList.forEach((color) => {
					const swatch = template.clone(),
						colorHex = hexedColor(color);
					swatch.css('background-color', colorHex);
					swatch.click(() => {
						colorPickerModel.colorPicked(colorHex);
					});
					container.append(swatch);
				});
			};
		widget.typeahead(colorHelper.findColor, changeColor, formatTemplate);
		template.remove();
		template.removeProp('data-mm-swatch-template');
		populateColors(standardSwatches, colorPickerModel.getColors());
		widget.on('show', () => {
			inMapSwatches.empty();
			populateColors(inMapSwatches, colorPickerModel.getInMapColors());
		});

		pickImageButton.click(async () => {
			const hideProgress = () => {
				pickImageButton.attr('disabled', '');
				pickImageButton.removeClass('disabled');
				imageUploadProgress.addClass('hidden');
			};
			if (optional.imagePicker) {
				pickImageButton.attr('disabled', true);
				pickImageButton.addClass('disabled');
				imageUploadProgress.removeClass('hidden');
				try {
					const result = await optional.imagePicker.pickImage();
					colorPickerModel.imagePicked(result);
				} catch(e) { //eslint-disable-line no-empty
				} finally {
					hideProgress();
				}
			}
			widget.trigger('pick-image-click-complete');
		});
	});
};
